import { useFetcher } from '@remix-run/react'
import { useEffect } from 'react'
import useUserPreferences from '#app/hooks/use-user-preferences'
import useURLSearchParams from '#app/hooks/useURLSearchParams'
import { cn } from '#app/utils/misc'
import SelectedStore from './selected-store'
import { StoreSelectorDrawer } from './store-selector-drawer'
import { StoreSelectorSheet } from './store-selector-sheet'

export interface SelectedStoresCookie {
	name: string
	key: string
}

const StoreSelector = () => {
	const userPreferences = useUserPreferences()
	const removeSelectedStoreFetcher = useFetcher()
	const searchParams = useURLSearchParams()
	const storesParam = searchParams.getAll('store')

	useEffect(() => {
		const removeSelectedStore = () => {
			removeSelectedStoreFetcher.submit(null, {
				method: 'POST',
				action: '/resources/removeSelectedStores',
			})
		}
		if (
			storesParam.length === 0 &&
			userPreferences?.selectedStores?.length > 0
		) {
			removeSelectedStore()
		}
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [])

	return userPreferences?.selectedStores &&
		userPreferences?.selectedStores?.length > 0 ? (
		<SelectedStore
			selectedStores={userPreferences?.selectedStores as SelectedStoresCookie[]}
		/>
	) : (
		<SelectStore />
	)
}

const SelectStore = () => {
	return (
		<div
			className={cn(
				'hidden flex-col justify-end space-y-1 bg-beige-50 px-4 py-2 md:flex md:flex-row md:space-y-0 md:px-[var(--plenty-padding)]',
			)}
		>
			{/* Desktop version (hidden on mobile, visible md and up) */}
			<div className="hidden md:block">
				<StoreSelectorSheet selectedStores={[]} />
			</div>

			{/* Mobile version (visible on mobile, hidden md and up) */}
			<div className="block md:hidden">
				<StoreSelectorDrawer selectedStores={[]} />
			</div>
		</div>
	)
}

export default StoreSelector
